export enum CallResult {
  ANSWERED = "Відповіли",
  ERROR = "Помилка",
}

export enum CallType {
  INCOMING = "Вx",
  OUTGOING = "Вих",
}
